<template>
	<div class="content mt-4">
		<div class="container">
			<div class="row">
				<div class="col-12 col-lg-8 mt-5">
					<span class="section-title">Profile</span>
					<div class="block dashboard--block">
						<div class="container">
							<div class="row">
								<div class="col-3 col-md-2">
									<div class="profile--photo" id="preview--profile" v-bind:style="{'background-image':'url(' + profile.profilePhotoUrl + ')',}">
									</div>
								</div>
								<div class="col-5 profile--center">
									<div class="profile--wrapper">
										<div class="profile--name">{{profile.name}}</div>
										<div class="profile--email">{{profile.email}}</div>
									</div>
								</div>
								<div class="col-4 profile--center">
									<div class="profile--wrapper">
										<div id="edit" @click="editProfile()" class="profile--button">{{editting ? 'Save Profile' : 'Edit Profile'}}</div>
									</div>
								</div>
							</div>
						</div>

						<div class="container" v-if="editting">
							<br />
							<hr />
							<br />
							<div class="row">
								<div class="col-12">
									<div class="page-editor--label">Profile picture</div> <input type="file" class="input--file" @change="changeAssets($event, 'profile')" accept="image/*" id="file-profile">
								</div>
								<br />
								<div class="col-12 mt-4">
									<div class="page-editor--label">Name</div>
									<input type="text" placeholder="Name" v-model="profile.name" name="name" class="input--text email login--input-bottom" />
								</div>

								<div class="col-12 mt-2">
									<div class="page-editor--label">Email</div>
									<input type="text" placeholder="Email" v-model="profile.email" name="email" class="input--text email login--input-bottom" />
								</div>

							</div>
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-4 mt-5">
					<span class="section-title">Settings</span>
					<div class="block plan">
						<div class="field--title">Email Updates</div>
						<br />
						<p class="plan--description">Do you want to receive email updates when you receive a new demo?</p>
						<div class="switch--wrapper" style="margin-top: 1em; position: unset;">
							<input id="checkbox" type="checkbox" class="checkbox" v-model="profile.sendUpdates" />
							<label for="checkbox" class="switch" style="margin-left: 0;">
								<span class="switch__circle">
									<span class="switch__circle-inner"></span>
								</span>
							</label>
						</div>
					</div>
				</div>

				<div class="col-12 col-lg-8 mt-2">
					<span class="section-title">Plan</span>
					<div class="block plan" v-if="plan != null">
						<span class="plan--title">{{plan ? 'Basic' : "Free"}}</span>
						<hr style="border-color: gray;" />
						<p class="plan--description">Your are currently on a <strong>{{plan ? 'Basic' : "Free"}}</strong> plan. </p>

						<p class="plan--description" v-if="plan == true">To cancel your subscription, download your invoices or change creditcard information please navigate to 'billing'.</p>
						<p class="plan--description" v-if="plan == false">To publish your contests and to use all ContestCrate features, upgrade to our 'Basic' plan!
							<br />
							<br />
							<span class="button--checkout" id="stripe"></span>
						</p>

					</div>
					<div>
						<div class="page-block--title"></div>
					</div>
				</div>

				<div class="col-12 col-lg-4 mt-2">
					<span class="section-title">Demo's</span>
					<div class="block dashboard--block">
						<p class="plan--description">Export all of your demo's to a CSV file.</p>
						<div id="edit" @click="exportDemos()" class="profile--button" style="float:left;">Generate CSV</div>
						<br />
						<br />
						<a download="contestcrate-export.csv" :href="demoDownloadURL" v-if="demoDownloadURL != null">
							<div id="edit" class="profile--button" style="float:left;">Download</div>
						</a>
					</div>
				</div>
			</div>
			<div class="row">

			</div>
		</div>
	</div>
</template>

<script>
	import axios from "axios";

	export default {
		name: "home",
		components: {},
		data() {
			return {
				plan: null,
				checkoutButton: null,
				profile: {},
				editting: false,
				demoDownloadURL: null,

			};
		},
		watch: {
			'profile.sendUpdates': function(newVal, oldVal) {
				console.log(newVal);
				console.log(oldVal);
				var self = this;
				axios({
						method: "POST",
						crossdomain: true,
						headers: {
							"Content-Type": "Content-Type:application/json"
						},
						url: "/user/update",
						data: {
							sendUpdates: self.profile.sendUpdates
						},
					})
					.then(function(response) {
						console.log(response);

					})
					.catch(function() {

						self.isLoading = false;
					});
			}
		},
		methods: {
			changeAssets(event, type) {
				var file = event.target.files[0];
				var reader = new FileReader();
				if (type == "profile") {
					reader.onloadend = function() {
						document.getElementById("preview--profile").style.backgroundImage = 'url("' + reader.result + '")';
					}
					if (file) {
						reader.readAsDataURL(file);
					} else {
						console.log("no file");
					}

				}
				this.updateProfile(event);
			},
			exportDemos() {
				this.isLoading = true;
				var self = this;

				axios.get("/demo/export", {
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
					.then(function(response) {
						self.isLoading = false;
						console.log(response);
						window.open('data:application/octet-stream,' + encodeURIComponent(response.data));
						self.downloadDemoFile('contestcrate-demos.csv', response.data)
					});
			},
			downloadDemoFile(filename, text) {
				this.demoDownloadURL = 'data:application/octet-stream,' + encodeURIComponent(text);
			},
			updateProfile(event) {
				var formData = new FormData();
				//var photo = document.querySelector('#profile--photo');
				var photo_field = event.target;

				this.isLoading = true;
				var self = this;

				if (photo_field.files[0]) {
					formData.append("photo", photo_field.files[0]);
					console.log("APPEND")
				}
				console.log(formData)

				axios.post("/user/update", formData, {
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
					.then(function(response) {
						self.isLoading = false;
						console.log(response);
					});
			},
			editProfile() {
				if (this.editting == true) {
					var self = this;
					axios({
							method: "POST",
							crossdomain: true,
							headers: {
								"Content-Type": "Content-Type:application/json"
							},
							url: "/user/update",
							data: self.profile,
						})
						.then(function(response) {
							console.log(response);

						})
						.catch(function() {

							self.isLoading = false;
						});
					this.editting = false;
				} else {
					this.editting = true;
				}
			},
			uploadAssets() {
				var formData = new FormData();
				var logo = document.querySelector('#file-logo');
				var background = document.querySelector('#file-background');
				console.log(logo);
				console.log(background);
				this.isLoading = true;
				var self = this;
				formData.append("organization_id", this.$globals.organization_id);

				if (logo.files[0]) {
					formData.append("logoImage", logo.files[0]);
				}

				if (background.files[0]) {
					formData.append("backgroundImage", background.files[0]);
				}

				formData.append("enabled", this.editted.enabled);

				axios.post("/contest/update/" + self.editted.customUrl, formData, {
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
					.then(function(response) {
						console.log(response);
						self.$globals.getPages();
						self.isLoading = false;
					});
			},
			getSubscription() {

			}
		},
		mounted() {
			var self = this;
			this.isLoading = true;
			axios({
					method: "GET",
					crossdomain: true,
					headers: {
						"Content-Type": "Content-Type:application/json"
					},
					url: "/user/me",
				})
				.then(function(response) {
					console.log(response);
					self.profile = response.data;
				})
				.catch(function(error) {
					self.errors = error.response.data;
					self.isLoading = false;
				});
		},
	};
</script>